// Время на рефакторинг этого файла не закладывалось, а время для задачи уже пробито
//tslint:disable:max-file-line-count
import { Action, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Config } from '@cian/config';
import { IGetVillageForMapResponse as IVillage } from '@cian/api-models/countryside-search/v1/get-village-for-map';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { IUndergroundMapWidgetContext } from '@cian/underground-map-widget';

import { IBSCenterInfo } from '../../api/bs_centers';
import { ICommercialSpecialty } from '../../api/commercial_specialties';
import { IDeveloperInfo } from '../../api/developers';
import { IExperiment } from '../../api/experiments';
import { IGeoDistrict } from '../../api/geo';
import { ILocation } from '../../api/locations';
import { INewbuildingInfo } from '../../api/newbuildings';
import {
  IServicePlaceWidgetMarkup,
  ISimilarNewobjectsData,
  ISimilarNewobjectsFromDeveloperData,
} from '../../filters/api';
import { IDirection } from '../../filters/api/directions';
import { TTag } from '../../filters/state/tags';
import { IJsonQuery, IJsonQueryDistrict } from '../../json_query';
import { IBreadcrumb, IOffer, ISerpDataQueristringToUri, EOfferExtensionType } from '../../offer/types';
import { ISimplifiedOfferCardPopupsState } from '../../serp/state/offer_card/simplified_card_popups';
import { ISuggestionsDistancesState } from '../../serp/state/suggestions';
import { IMakeRequest } from '../../utils/request';
import { IHideOffer } from '../../serp/state/hide_offer';
import { IFeedbackComplaintState } from '../../serp/state/offer_card/feedback_complaint';
import { ITrackingPageData } from '../../serp/state/tracking';
import {
  IKpOffers,
  EMaxAuctionService,
  ICollectionItem,
} from '../../repositories/search-offers/v2/search-offers-desktop.data';
import { IDemandReducerState } from '@cian/demand-trap-widget';
import { IVerifyPhoneReducer } from '@cian/sms-validation-widget';
import { TStatusFetch } from '../../serp/state/commecial_survey';
import { IAbUseExperiment } from '../../types/abUseExperiments';
import { IFeatureToggleState } from './types/featureToggle';
import { INewbuildingConsultant } from '../../types/newbuildingConsultant';
import { ICrosslinkBlockSchema } from '../../types/seo';
import { IFavoritesAssignWidgetState } from '@cian/favorites-assign-widget';
import { ICoworkingExperiments } from '../../serp/state/coworking_experiments/combinedCoworkingExperiments';

export interface INewbuildings {
  [key: number]: string;
}
export interface INewbuildingHouses {
  [key: string]: string;
}

export interface IBsCenters {
  [key: number]: string;
}
export interface ICoworkings {
  [key: number]: string;
}

export interface IDevelopers {
  [key: number]: string;
}

export interface ILocations {
  [key: number]: string;
}

export interface IDistricts {
  [key: number]: string;
}

export interface IStreets {
  [key: number]: string;
}

export interface IHouses {
  [key: number]: string;
}

export interface IUndergrounds {
  [key: number]: IStationInfo;
}

export interface IRailway {
  [key: number]: string;
}

export interface IStationInfo {
  name: string;
  color?: string;
  releaseYear?: number;
}

export interface IConstructingStations {
  [key: number]: IConstructionStation;
}

export interface IConstructionStation {
  name: string;
  releaseYear: number;
}

export interface ITagsData {
  newbuildings: INewbuildings;
  newbuildingHouses: INewbuildingHouses;
  bsCenters: IBsCenters;
  developers: IDevelopers;
  locations: ILocations;
  districts: IDistricts;
  streets: IStreets;
  houses: IHouses;
  undergrounds: IUndergrounds;
  directions: IDirection[];
  commercialSpecialties: ICommercialSpecialty[];
  railways: IRailway;
  coworkings: ICoworkings;
}

export type TCurrentLocation = ILocation | 'moscow_mo' | 'spb_lo';

export interface IFiltersState {
  backup: IJsonQueryBackup | undefined;
  regions: ILocation[];
  currentLocation: TCurrentLocation;
  locationSwitcher: ILocationSwitcher;
  districtsSwitcher: IDistrictsSwitcher;
  jsonQuery: IJsonQuery;
  nextJsonQuery: IJsonQuery;
  tags: TTag[];
  tagsData: ITagsData;
  tagsOptions: ITagsOptions;
  jsonQueryCountRefresing: boolean;
  jsonQueryCount: number | undefined;
  jsonQueryFullUrl?: string;
  jsonQueryUrl?: string;
  directionsModal: IDirectionsModalState;
  queryString?: string;
  userInput?: string;
  metaHeader?: string;
}

export interface ILocationSwitcher {
  cities: ILocation[] | undefined;
  isCitiesLoading: boolean;
  isLocationSwitcherOpened: boolean;
  selectedRegion: TCurrentLocation | undefined;
  selectedCity: ILocation | undefined;
  isAutocompleteLoading: boolean;
  autocompleteSuggestions: ILocation[] | undefined;
}

export interface IDistrictsSwitcher {
  isDataLoading: boolean;
  districts: IGeoDistrict[] | undefined;
  selectedLocation: TCurrentLocation | undefined;
  selectedDistricts: IJsonQueryDistrict[];
}

export interface IJsonQueryBackup {
  jsonQuery: IJsonQuery;
  tags: TTag[];
}

export interface ITagsOptions {
  isFitInOneLineEnabled: boolean;
}

export interface ILink {
  url: string;
  title: string;
}

export interface IFastLink {
  uri: string;
  title: string;
}

export interface IAvgPriceInformer {
  price: number;
  currency: 'rur' | 'eur' | 'usd';
}

export interface IQuickLinks {
  level: number;
  links: IQuickLink[] | null;
}

export interface IQuickLink {
  url: string;
  offersCount: number | null;
  title: string;
}

export interface IPrint {
  enabled: boolean;
  showComments: boolean;
  showPhones: boolean;
}

export interface IResultsState {
  aggregatedOffers: number;
  extendedOffersCount: number;
  avgPriceInformer: IAvgPriceInformer | null;
  bsCenterInfo: IBSCenterInfo | null;
  commentingBlockedAgents: number[];
  commentingBlockedOffers: number[];
  commentingErroneousAgents: number[];
  commentingErroneousOffers: number[];
  developerInfo: IDeveloperInfo | null;
  villageInfo?: IVillage | null;
  fastLinks: IFastLink[] | null;
  fullUrl: string;
  isHiddenBaseSearchTooltipVisible: boolean;
  jsonQuery: IJsonQuery;
  kp: IKpOffers | null;
  newbuildingInfo: INewbuildingInfo | null;
  offers: IOffer[];
  paginationUrls: string[];
  qsToUris: ISerpDataQueristringToUri | null;
  queryString: string;
  quickLinks: IQuickLinks | null;
  ratingBlockedAgents: number[];
  seo: ISeoState;
  seoLinks?: ILink[] | null;
  subscriptionsStates: ISubscriptionsStates;
  suggestions: IOffer[] | null;
  suggestionsQuery: string | null;
  totalOffers: number;
  extensionTypes: EOfferExtensionType[];
}

export interface ISimilarLink {
  fullUrl: string;
  id: number;
  text: string;
}

export interface ISeoState {
  keywords: string | null;
  text: string | null;
  h1: string | null;
  description: string | null;
  title: string | null;
  metaDescription?: string;
  similarLinks?: ISimilarLink[];
  noindex?: boolean;
  canonical?: string;
}

export interface IUserGADataLayerData {
  criteoNewCustomer: number;
  abGroup: number;
  realtyUserId: string;
  userId: string;
  criteoEmail: string;
  userType: string;
  email: string;
}

export interface IUserPhone {
  phone: string;
  confirmed: boolean;
}

export interface IUserNotSignedIn {
  isAuthenticated: false;
}

export interface IUserSignedIn {
  isAuthenticated: true;
  /**
   * Cian UserId
   */
  id: number;
  /**
   * Realty UserId
   */
  userId: number;
  email: string;
  balance: number;
  accountType: 'natural' | 'legal';
  agentAccountType: 'specialist' | 'agency';
  isAgent: boolean;
  isProfi: boolean;
  isModerator: boolean;
  isNew: boolean;
  isSubscriptions: boolean;
  userType: string;
  tariff: string[];
  phones: IUserPhone[] | undefined;
  firstName: string | null;
  lastName: string | null;
  publicProfile: boolean;
  displayName: string | null;
  permissions: {
    canViewUsers: boolean;
    canViewListingSort: boolean;
    canViewAnnouncements: boolean;
    canUseHiddenBase: boolean;
    canModerateUsers: boolean;
    canModerateAnnouncements: boolean;
    canModerateAnnouncementsExpert: boolean;
  };

  webimHash?: string;
}

export type TUser = IUserNotSignedIn | IUserSignedIn;

export interface IDirectionsModalState {
  isVisible: boolean;
  isLoading?: boolean;
  regionId?: number;
  data: IDirection[];
}

export interface ILoginMotivationPopupOnFavorite {
  isActive: boolean;
  shownId?: number;
}

export interface ITrackingUserData {
  abGroup: number;
  type: string;
  userId?: string;
  cianUserId?: string;
  email?: string;
}

export interface ITrackingData {
  user: ITrackingUserData;
  page: ITrackingPageData;
}

export interface ICommercialTrackingProduct {
  id?: number;
  offerType: string;
  position: number;
}

export interface ICommercialTrackingOfferParams {
  name: string;
  ec: string;
  ea?: string;
  el?: string;
  modelVersion?: string;
  searchConditions?: IJsonQuery;
  products: ICommercialTrackingProduct[];
  page: {
    listingType: string;
    pageNumber: number;
    queryString: string;
    offersQty: number;
    pageType: string;
    siteType: string;
  };
  user: {
    userId?: number;
    abGroup?: number;
  };
}

export interface ISerializableAppState {
  breadcrumbs: IBreadcrumb[];
  currentPath: string;
  deviceType: TDeviceType;
  experiments: IExperiment[];
  abUseExperiments: IAbUseExperiment[];
  filters: IFiltersState;
  isAdvancedModalVisible: boolean;
  isDistrictModalVisible: boolean;
  isFetching: boolean;
  isMapModalVisible: boolean;
  isMetroModalVisible: boolean;
  isOfficeCalculatorVisible: boolean;
  isPromotionMobileClosed: boolean;
  isSignInTriggerModalOpen: boolean;
  searchOffersApiBaseUrl: string;
  lastModified: string | null;
  loginMotivationPopupOnFavorite: ILoginMotivationPopupOnFavorite;
  print: IPrint;
  profileSessionKey: string;
  results: IResultsState;
  seoCrossLinks: ICrosslinkBlockSchema[] | null;
  seoBotCatcherLinks: ILink[];
  similarNewobjects: ISimilarNewobjectsData[] | null;
  similarNewobjectsFromDeveloper: ISimilarNewobjectsFromDeveloperData[];
  suggestionsDistances?: ISuggestionsDistancesState;
  hideOffer: IHideOffer;
  suggestionDistancesSeoText?: string;
  user: TUser;
  userAgent: string;
  isHomeOwner?: boolean;
  userGADataLayerData: IUserGADataLayerData | null;
  currentSubdomain: string;
  simplifiedOfferCardPopupsState: ISimplifiedOfferCardPopupsState;
  servicePlaceWidgetMarkups: IServicePlaceWidgetMarkup[];
  villageName?: string;
  showPushNotification?: boolean;
  isStalkerBannerShown: boolean;
  searchUuid: string | null;
  isQaMode: boolean;
  complaintFeedbackFrom: IFeedbackComplaintState;
  villagesLink?: string;
  constructingStations?: IConstructingStations;
  /** Максимальная ставка аукциона на выдаче */
  maxAuctionBet: number;
  /** Максимальная услуга выдачи */
  maxAuctionService?: EMaxAuctionService;
  isAutoOfferChangeTooltipVisible?: boolean;
  mlRankingGuid: string | null;
  mlRankingModelVersion: string | null;
  isMlRankingResponseCached: boolean;
  /** id запроса. На каждый запрос приходит новый id */
  searchRequestId: string;
  isNewbuildingsOnly: boolean;
  demand?: IDemandReducerState;
  verifyPhone?: IVerifyPhoneReducer;
  soprApi: string;
  isCountrysideTrapEnabled: boolean;
  isPromotionsInOffersEnabled: boolean;
  isOfferInSavedSearch?: boolean;
  collections: {
    items: ICollectionItem[];
  };
  isPromoCollectionsEnabled: boolean;
  excludedUtilitiesTermsRegions: number[];
  featureToggle: IFeatureToggleState;
  isRedesignEnabled: boolean;
  isFiltersRedesignEnabled: boolean;
  specialties: ICommercialSpecialty[];
  isCommercialSurveyWidgetModalOpen: boolean;
  commecialSurveyWidgetModalStatusFetch: TStatusFetch;
  commercialTrackingOfferParams?: ICommercialTrackingOfferParams;
  newbuildingConsultant: INewbuildingConsultant;
  isCoworkingWorkplaceAvailable: boolean;
  favoritesAssignWidget: IFavoritesAssignWidgetState;
  auctionBanks: number[];
  coworkingExperiments: ICoworkingExperiments;
  isCoworkingExperimentsEnabled: boolean;
  isCommercialOwnerFilterAvailable: boolean;
}

export type TDeviceType = 'mobile' | 'tablet' | 'desktop';

export interface IWidgets {
  undergroundMapSchemeWidgetService: IUndergroundMapWidgetContext;
}

export interface IAppState extends ISerializableAppState {
  makeRequest: IMakeRequest;
  httpApi: IHttpApi;
  logger: ILogger;
  config: Config;
  widgets: IWidgets | undefined;
}

export interface ISubscriptionsStates {
  nothingFound: TSubscriptionState;
  bottom: TSubscriptionState;
}

export type TSubscriptionState = 0 | 1 | 2 | 3;
export const SubscriptionState = {
  Default: 0 as 0,
  Fetching: 1 as 1,
  Succeeded: 2 as 2,
  Failed: 3 as 3,
};

export type Dispatch<A extends Action = AnyAction> = ThunkDispatch<IAppState, {}, A>;
